<ng-container *ngIf="!isLoading; else loadingTemplate">
  <h2 class="popup-heading m-0" mat-dialog-title>
    {{!last4 ? 'Payment Method Required' : 'Subscription Confirmation'}}
  </h2>
  <div class="content">
    <p [ngClass]="!last4 ? '' : ''">
      <ng-container *ngIf="last4; else noCard">
        Are you sure you want to subscribe to the
        <strong>{{subscribetionPlan === 'Hobbyist' ? 'Hobbyist' : subscribetionPlan}}</strong>
        plan? Your credit card ending in <strong>{{last4}}</strong> will be charged for <strong>$69.99</strong>.
      </ng-container>
      <ng-template #noCard>
        Please add a credit card from the Payment Methods section.
      </ng-template>
    </p>

    <div class="action-buttons" align="end">
      <button class="cancel-popup" mat-stroked-button (click)="!last4 ? goToPayment() : close()">
        {{!last4 ? 'Go to Payment Methods' : 'Cancel'}}
      </button>
      <button class="save" mat-flat-button (click)="Confirm()" *ngIf="last4"
        [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}">
        <mat-icon *ngIf="processing">
          <mat-spinner class="accent-spinner" diameter="20"></mat-spinner>
        </mat-icon>
        Confirm
      </button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <div class="loader-wrapper">
    <div class="arc-spinner"></div>
  </div>
</ng-template>